(function (angular) {
    'use strict';

    var Html5AudioPlayer = (function () {


        /**
         * 
         */
        function Html5AudioPlayer() {
            this.sounds = [];
            // Fix up prefixing
            this.isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g) || !!navigator.userAgent.match(/Edge/g);

            if (!this.isIE) {
                window.AudioContext = window.AudioContext || window.webkitAudioContext;
                this.context = new AudioContext();
            }

        }

        /**
         * 
         */
        Html5AudioPlayer.prototype.loadSound = function (name, url) {

            var self = this;
            return new Promise(function (resolve, reject) {

                if (!self.isIE) {

                    var request = new XMLHttpRequest();
                    request.open('GET', url, true);
                    request.responseType = 'arraybuffer';

                    // Decode asynchronously
                    request.onload = function () {
                        self.context.decodeAudioData(request.response, function (buffer) {
                            self.sounds.push({
                                buffer: buffer,
                                name: name,
                                url: url
                            });
                            resolve(true);

                        }, function (e) {
                            console.error("Failed to decodeAudioData " + url, e);
                            reject(e);
                        });
                    }
                    request.send();
                } else {

                    try {

                        var data = {
                            audio: new Audio(url),
                            name: name,
                            url: url
                        }
                        self.sounds.push(data);

                        resolve(true);
                    } catch (e) {
                        console.error("Failed to load " + url, e);
                        reject(e);
                    }
                }

            });

        };
        /**
         * 
         */
        Html5AudioPlayer.prototype.playSound = function (name) {

            var sound = this.sounds.find(function (s) {
                return s.name === name;
            })

            if (!this.isIE) {

                if (sound) {
                    var source = this.context.createBufferSource(); // creates a sound source
                    source.buffer = sound.buffer;                    // tell the source which sound to play
                    source.connect(this.context.destination);       // connect the source to the context's destination (the speakers)
                    source.start(0);                           // play the source now

                }
            } else {
                if (sound) {
                    try {
                        sound.audio.play();
                    } catch (e) {
                        console.error("Failed to play sound");
                    }
                }
            }

        };

        return Html5AudioPlayer;
    }());

    angular.module('chat2')

        /**
         *
         */
        .factory('Html5AudioPlayer', [
            function () {
                var html5AudioPlayer = new Html5AudioPlayer();
                return html5AudioPlayer;
            }]);

})(window.angular);
